export default "query isRoleExist($check: Int!,$field: String) {\n  isRoleExist(check: $check,field: $field) \n}";